@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as c;
@use "styles/abstracts/variables" as v;

.toolbar {
  position: absolute;
  z-index: v.$z-index-map-tools;
  top: 16px;
  right: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }

  @include c.containerMedia(v.$tablet-breakpoint) {
    top: 12px;
    right: 12px;
    flex-direction: column;
    align-items: flex-end;
    gap: 15px;
  }
}

.toolbarStart {
  @include c.containerMedia(v.$tablet-breakpoint) {
    order: -1;
  }
}

.toolsTabsWrapper {
  display: flex;
  gap: 8px;
  text-align: end;
  align-items: center;
  width: auto;
  margin-bottom: 0;

  @include c.containerMedia(v.$tablet-breakpoint, "min") {
    display: none;
  }
}

.tabsList {
  display: flex;
  align-items: center;
  padding: 4px;
  gap: 8px;
  height: 36px;
  background: v.$palette-white;
  border-radius: 10px;
  box-shadow: v.$shadow-2;

  li {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 28px;
    padding: 4px 16px;
    @include t.text(12px, 20px, 600);
    color: v.$palette-gray-900;
    text-transform: capitalize;
    cursor: pointer;

    @include c.containerMedia(780px, "min") {
      padding: 4px 14px;
    }

    @include c.containerMedia(v.$desktop-tools-tabs-breakpoint, "min") {
      padding: 4px 16px;
    }

    svg path {
      fill: v.$palette-gray-900;
    }

    span {
      display: none;

      @include c.containerMedia(v.$tablet-breakpoint, "min") {
        display: inline;
      }
    }

    & + li {
      &::before {
        content: "";
        position: absolute;
        left: 0;
        height: 16px;
        width: 1px;
        background: v.$palette-gray-300;
      }
    }

    &.active {
      background: v.$palette-blue-light-2;
      color: v.$palette-blue;
      border-radius: 8px;

      &::before {
        display: none;
      }

      & + li {
        &::before {
          display: none;
        }
      }

      svg path {
        fill: v.$palette-blue;
      }
    }
  }
}

.contentWrapper {
  position: absolute;
  z-index: v.$z-index-tabs-list;
  top: 120px;
  left: 16px;
  width: calc(100% - 32px);
  background: v.$palette-white;
  border-radius: 16px;
  height: calc(100% - 90px);
  overflow: hidden;
  box-shadow: v.$shadow-1;

  &.hidden {
    display: none;
  }

  @include c.containerMedia(v.$js-defined-mobile-breakpoint, "min") {
    top: 64px;
  }

  @include c.containerMedia(v.$desktop-tools-tabs-breakpoint, "min") {
    top: 80px;
    left: v.$panel-wrapper-width;
    width: calc(100% - v.$panel-wrapper-width - 17px);
  }
}

:global([data-theme="dark"]) {
  .tabsList li:not(.active) {
    svg path {
      fill: v.$palette-pure-white;
    }
  }
}
